import { UUIDPathRegex } from '@cbgms/base/utils/uuid'

export const WorkOrderUrl = '/workorders'
export const WorkOrderDetailUrl = `/workorders/:workorderUUID(${UUIDPathRegex})`

export const WorkOrderQuotationsUrl = '/workorders-quotations'
export const WorkOrderQuotationDetailUrl = '/workorders-quotations/:QuotationUUID'
export const OrderQuotationDetailUrl = '/orders-quotations/:QuotationUUID'

export const WorkOrderInvoicesUrl = '/workorders-invoices'

export const WarrantyClaimsUrl = '/warranty-claims'
export const WomPlusUrl = '/wom-connect'
